import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import type { CategoryItem } from "./categoryItem";
import { DEFAULT_CATEGORY_CONFIG } from "./discoveryDefaults";
import { EFFECT_UI_CONFIG } from "./effectConfig";

export function mapEffectDataToItems(
  effectData: AutocompleteData[],
): CategoryItem[] {
  return effectData.map((item) => {
    const uiConfig = EFFECT_UI_CONFIG[item.value];
    if (!uiConfig)
      console.warn(`[effectData] No UI config for: "${item.value}"`);
    const { image, accentColor } = uiConfig ?? DEFAULT_CATEGORY_CONFIG;
    return {
      id: item.value.toLowerCase().replace(/_/g, "-"),
      name: item.name,
      description: item.description ?? "",
      filterValue: item,
      image,
      accentColor,
    };
  });
}
